import { ChangeDetectionStrategy, Component, input, output, signal, WritableSignal } from '@angular/core';
import { form, FormField } from '@angular/forms/signals';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { StripeVerificationSessionAdminFilterKey, ZoudashUtils } from '@workspace/data-types';
import {
  AbstractSignalFormComponent,
  DataHeaderFilter,
  FilterChangedDetection,
  FilterRecord,
} from '@workspace/ng-aura';
import { StripeVerificationSessionColumnKey } from '../abstract-stripe-verification-sessions-data-table.component';

export interface StripeVerificationSessionFilterModel {
  stripeSessionId: string;
}

@Component({
  selector: 'core-stripe-verification-sessions-data-table-filter',
  templateUrl: './stripe-verification-sessions-data-table-filter.component.html',
  imports: [FormField, MatFormFieldModule, MatInputModule, MatListModule, MatSlideToggleModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StripeVerificationSessionsDataTableFilterCoreComponent extends AbstractSignalFormComponent<
  Partial<Record<StripeVerificationSessionAdminFilterKey, string | string[]>>,
  StripeVerificationSessionFilterModel
> {
  filterChanged = output<FilterChangedDetection>();
  currentFilterView = input<string | null>(null);
  filters = input.required<DataHeaderFilter<StripeVerificationSessionColumnKey>[]>();
  stripeSessionFilterKey = StripeVerificationSessionAdminFilterKey;

  override model: WritableSignal<StripeVerificationSessionFilterModel> =
    signal<StripeVerificationSessionFilterModel>({
      stripeSessionId: '',
    });

  override formTree = form(this.model);

  override emitDto(
    newDto: Partial<Record<StripeVerificationSessionAdminFilterKey, string | string[]>>,
  ): void {
    this.filterChanged.emit({
      filter: newDto as FilterRecord,
      changed: !ZoudashUtils.isEqual(newDto, this.ogValue),
    });
  }

  protected override buildModelFromDto(
    dto: Partial<Record<StripeVerificationSessionAdminFilterKey, string | string[]>>,
  ): StripeVerificationSessionFilterModel {
    const rawVal = dto?.stripeSessionId;
    return {
      stripeSessionId: Array.isArray(rawVal) ? (rawVal[0] ?? '') : (rawVal ?? ''),
    };
  }

  protected override buildDtoFromModel(
    model: StripeVerificationSessionFilterModel,
  ): Partial<Record<StripeVerificationSessionAdminFilterKey, string | string[]>> {
    const dto: Partial<Record<StripeVerificationSessionAdminFilterKey, string | string[]>> = {
      stripeSessionId: model.stripeSessionId.trim() ? model.stripeSessionId.trim() : undefined,
    };
    return Object.fromEntries(Object.entries(dto).filter(([_, v]) => v != null)) as Partial<
      Record<StripeVerificationSessionAdminFilterKey, string | string[]>
    >;
  }
}
